import { Box, Typography } from "@mui/material";
import { DetailsView } from "./DetailsView";
import { SummaryBox } from "./SummaryBox";
import { SummaryCardProps } from "./SummaryCardProps.types";

export function SummaryCard({ title = "-", info = "total users", color }: SummaryCardProps) {
  return (
    <SummaryBox color={color}>
      <DetailsView info={info} title={title} />
    </SummaryBox>
  );
}
